// AUTO-GENERATED by scripts/generate-analytics.cjs — DO NOT EDIT MANUALLY
// Source: tracking-data/*.csv — Generated: 2026-07-02T06:07:03.281Z
/* eslint-disable */
import type { EventName } from "./events";

export const EVENT_PROP_KEYS: Record<EventName, readonly string[]> = {
  "accessibility_alerts_closed": ["alerts_count"],
  "accessibility_alerts_viewed": ["alerts_count", "brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "accessibility_guide_viewed": ["brand_id", "brand_name", "business_id", "entry_page", "entry_page_url", "guide_name", "place_name"],
  "accessibility_profile_form_closed": [],
  "accessibility_profile_form_opened": [],
  "accessibility_profile_updated": [],
  "account_auto_logged_in": ["brand_id", "brand_name", "business_id", "place_name"],
  "account_created": ["account_creation_method"],
  "account_deleted": [],
  "account_logged_in": ["auth_provider", "brand_id", "brand_name", "business_id", "place_name"],
  "account_logged_out": [],
  "account_login_failed": ["auth_provider", "error_type"],
  "account_privacy_changed": ["setting_type", "setting_value"],
  "activity_filtered": ["activity_type", "date_range", "filter_type"],
  "activity_view_changed": ["activity_type", "interaction_method", "previous_activity_type"],
  "activity_viewed": ["activity_type", "entry_page", "entry_page_url"],
  "add_alert_form_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "add_alert_form_opened": ["brand_id", "brand_name", "business_id", "existing_alerts_count", "place_name"],
  "add_info_menu_closed": [],
  "add_info_menu_opened": ["brand_id", "brand_name", "business_id", "entry_page", "place_name"],
  "add_mapper_note_form_closed": ["brand_id", "brand_name", "business_id", "mapper_note_type", "place_name"],
  "add_mapper_note_form_opened": ["brand_id", "brand_name", "business_id", "mapper_note_type", "place_name"],
  "add_note_menu_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "add_note_menu_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "add_space_discard_dialog_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "add_space_discard_dialog_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "add_space_form_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "add_space_form_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name"],
  "alert_added": ["alert_frontend_status", "alert_location_name", "alert_status", "alert_title", "alert_type", "alerts_added_count", "alerts_count", "brand_id", "brand_name", "business_id", "mapper_note_type", "photos_count", "place_name"],
  "alert_added_confirmation_viewed": ["alerts_count", "brand_id", "brand_name", "business_id", "place_name"],
  "alert_deleted": ["alert_age_days", "alert_frontend_status", "alert_location_name", "alert_status", "alert_title", "alert_type", "alerts_count", "brand_id", "brand_name", "business_id", "place_name"],
  "alert_edited": ["alert_frontend_status", "alert_location_name", "alert_status", "alert_title", "brand_id", "brand_name", "business_id", "photos_count", "place_name"],
  "alert_flag_cta_activated": ["alert_title", "brand_id", "brand_name", "business_id", "place_name"],
  "alert_flagged": ["alert_title", "brand_id", "brand_name", "business_id", "photos_count", "place_name"],
  "alert_resolved": ["alert_age_days", "alert_title", "alert_type", "brand_id", "brand_name", "business_id", "place_name"],
  "alert_unvoted": ["alert_title", "brand_id", "brand_name", "business_id", "place_name", "vote_type"],
  "alert_voted": ["alert_age_days", "alert_title", "brand_id", "brand_name", "business_id", "photos_count", "place_name", "vote_type"],
  "analytics_page_viewed": ["brand_id", "brand_name", "business_id", "entry_page", "entry_point", "place_name"],
  "analytics_site_changed": ["brand_id", "brand_name", "business_id", "place_name", "previous_business_id"],
  "app_accessibility_setting_changed": ["setting_type", "setting_value"],
  "app_accessibility_viewed": ["entry_page", "entry_page_url"],
  "area_map_results_viewed": ["area_map_name", "entry_index", "filters_count", "place_category", "results_count", "search_coordinate", "search_method", "search_query", "search_radius_km", "selected_filter", "view_type"],
  "area_map_share_cta_activated": [],
  "area_map_viewed": ["area_map_name", "results_count"],
  "assign_alt_text_discard_dialog_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "assign_alt_text_discard_dialog_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "assign_alt_text_step_viewed": ["brand_id", "brand_name", "business_id", "navigation_direction", "photo_index", "place_header_name", "place_name", "previous_step_index", "step_index", "step_name", "tag_status"],
  "assign_tags_discard_dialog_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "assign_tags_discard_dialog_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "assign_tags_exited": ["brand_id", "brand_name", "business_id", "place_name"],
  "assign_tags_step_viewed": ["brand_id", "brand_name", "business_id", "navigation_direction", "place_header_name", "place_name", "place_space_name", "previous_step_index", "step_index", "step_name"],
  "auth_email_submitted": ["auth_result"],
  "auth_form_closed": ["auth_screen"],
  "auth_form_opened": ["entry_page", "entry_point"],
  "auth_password_reset_viewed": [],
  "auth_password_viewed": [],
  "auth_signup_viewed": ["step_index", "step_name"],
  "auth_social_cta_activated": ["auth_provider"],
  "badges_viewed": ["current_level", "current_points", "entry_page", "entry_page_url", "points_to_next_level"],
  "block_user_cta_activated": [],
  "block_user_form_closed": [],
  "block_user_form_opened": [],
  "blog_cta_activated": [],
  "brand_viewed": [],
  "business_claimed": ["brand_id", "brand_name", "business_id", "contact_method", "place_name"],
  "change_cover_photo_form_closed": [],
  "change_cover_photo_form_opened": ["entry_page"],
  "change_location_list_closed": [],
  "change_location_list_viewed": [],
  "change_location_map_form_closed": [],
  "change_location_map_form_opened": [],
  "claim_business_form_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "claim_business_form_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "clear_space_info_dialog_closed": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "clear_space_info_dialog_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "community_subscribe_cta_activated": [],
  "connected_space_list_viewed": ["brand_id", "brand_name", "business_id", "connected_space_count", "place_header_name", "place_name", "place_space_name"],
  "cover_photo_updated": ["cover_photo_type", "photo_source"],
  "create_saved_list_form_closed": [],
  "create_saved_list_form_opened": [],
  "custom_info_added": ["brand_id", "brand_name", "business_id", "custom_info_name", "custom_info_status", "guide_type", "place_name"],
  "custom_info_deleted": ["brand_id", "brand_name", "business_id", "custom_info_name", "guide_type", "place_name"],
  "custom_info_edited": ["brand_id", "brand_name", "business_id", "custom_info_name", "custom_info_status", "guide_type", "place_name"],
  "custom_info_editor_closed": ["brand_id", "brand_name", "business_id", "custom_info_name", "place_name"],
  "custom_info_editor_opened": ["brand_id", "brand_name", "business_id", "custom_info_name", "place_name"],
  "custom_info_reordered": ["brand_id", "brand_name", "business_id", "place_name"],
  "delete_account_dialog_closed": [],
  "delete_account_dialog_opened": [],
  "delete_saved_place_list_dialog_closed": ["places_count"],
  "delete_saved_place_list_dialog_opened": ["places_count"],
  "delete_saved_search_dialog_closed": [],
  "delete_saved_search_dialog_opened": [],
  "delete_space_dialog_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "delete_space_dialog_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "delete_team_dialog_closed": [],
  "delete_team_dialog_opened": [],
  "device_permission_changed": ["permission_state", "permission_type"],
  "device_permissions_viewed": ["entry_page", "entry_page_url"],
  "duplicate_space_form_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "duplicate_space_form_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "edit_alert_form_closed": ["alert_id", "brand_id", "brand_name", "business_id", "place_name"],
  "edit_alert_form_opened": ["alert_id", "brand_id", "brand_name", "business_id", "place_name"],
  "edit_space_discard_dialog_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "edit_space_discard_dialog_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "edit_space_form_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "edit_space_form_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "edit_tags_viewed": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name", "tag_status"],
  "email_app_cta_activated": [],
  "experience_flagged": ["brand_id", "brand_name", "business_id", "experience_type", "photos_count", "place_name"],
  "experience_shared": ["brand_id", "brand_name", "business_id", "photos_count", "place_name", "rating"],
  "external_link_cta_activated": ["link_destination"],
  "filter_applied": ["custom_opening_hour_day", "custom_opening_hour_time", "filter_type", "filters_count", "selected_filter", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "filter_cleared": ["filters_count", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "filter_closed": ["filter_type", "filters_count", "selected_filter", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "filter_opened": ["filter_type", "filters_count", "selected_filter", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "finish_tagging_viewed": ["brand_id", "brand_name", "business_id", "place_name"],
  "flag_alert_form_closed": ["alert_title", "brand_id", "brand_name", "business_id", "place_name"],
  "flag_alert_form_opened": ["alert_title", "brand_id", "brand_name", "business_id", "place_name"],
  "flag_closed": ["brand_id", "brand_name", "business_id", "place_info_type", "place_name"],
  "flag_experience_form_closed": ["brand_id", "brand_name", "business_id", "experience_type", "place_name"],
  "flag_experience_form_opened": ["brand_id", "brand_name", "business_id", "experience_type", "place_name"],
  "flag_photo_form_closed": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "flag_photo_form_opened": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "flag_space_form_closed": [],
  "flag_space_form_opened": ["alttext_state", "brand_id", "brand_name", "business_id", "photo_index", "place_name"],
  "flag_user_cta_activated": [],
  "flag_user_form_closed": [],
  "flag_user_form_opened": [],
  "forgot_password_cta_activated": [],
  "guide_added": ["brand_id", "brand_name", "business_id", "guide_name", "guide_status", "guide_type", "place_name", "protection_type", "space_count"],
  "guide_deleted": ["brand_id", "brand_name", "business_id", "guide_name", "guide_status", "guide_type", "place_name", "space_count"],
  "guide_duplicated": ["brand_id", "brand_name", "business_id", "guide_name", "guide_status", "guide_type", "place_name", "space_count"],
  "guide_edited": ["brand_id", "brand_name", "business_id", "guide_name", "guide_status", "guide_type", "place_name", "protection_type", "space_count"],
  "guide_editor_closed": ["brand_id", "brand_name", "business_id", "guide_name", "place_name"],
  "guide_editor_opened": ["brand_id", "brand_name", "business_id", "guide_name", "place_name"],
  "guide_link_copy_cta_activated": ["brand_id", "brand_name", "business_id", "guide_name", "guide_status", "guide_type", "place_name"],
  "home_page_viewed": ["entry_page", "entry_page_url", "entry_type"],
  "leave_team_dialog_closed": [],
  "leave_team_dialog_opened": [],
  "list_filtered": ["brand_id", "brand_name", "business_id", "filter_results_count", "list_type", "place_name", "search_query", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "location_changed": ["selection_method"],
  "location_cta_activated": [],
  "manage_account_viewed": [],
  "manage_notification_form_closed": [],
  "manage_notification_form_opened": ["enabled_notification"],
  "manage_notifications_viewed": ["entry_page", "entry_page_url", "notification_type"],
  "manage_photo_viewed": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name", "tag_status"],
  "map_location_centered": [],
  "map_view_changed": ["view_type"],
  "map_zoomed": ["zoom_direction", "zoom_level"],
  "my_business_viewed": ["brand_id", "brand_name", "business_id", "place_name"],
  "nav_tree_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "nav_tree_viewed": ["brand_id", "brand_name", "business_id", "place_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "nearby_required_dialog_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "nearest_results_cta_activated": ["search_location_source"],
  "neighborhood_viewed": ["city_name"],
  "notification_read": ["brand_id", "brand_name", "business_id", "place_name"],
  "notification_view_changed": ["interaction_method", "notification_type", "previous_notification_type"],
  "notifications_all_read": ["notifications_marked_read_count"],
  "notifications_filter_toggled": ["filter_state", "filter_type"],
  "notifications_viewed": ["entry_page", "entry_page_url", "notification_type", "unread_notifications_count"],
  "onboarding_completed": [],
  "onboarding_skipped": ["step_index", "step_name"],
  "onboarding_step_viewed": ["navigation_direction", "previous_step_index", "step_index", "step_name"],
  "other_cities_viewed": [],
  "password_reset_completed": [],
  "password_reset_request_form_closed": [],
  "password_reset_request_form_opened": [],
  "password_reset_requested": [],
  "password_updated": [],
  "password_visibility_toggled": ["visibility_state"],
  "personal_details_updated": [],
  "photo_action_menu_closed": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "photo_action_menu_opened": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "photo_alt_text_toggled": ["alttext_state", "brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "photo_collection_view_changed": ["brand_id", "brand_name", "business_id", "photo_collection_type", "photo_index", "place_name", "previous_photo_collection_type"],
  "photo_flag_cta_activated": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "photo_flagged": ["brand_id", "brand_name", "business_id", "photo_index", "photos_count", "place_header_name", "place_name", "place_space_name"],
  "photo_gallery_closed": ["brand_id", "brand_name", "business_id", "entry_page", "place_name"],
  "photo_gallery_viewed": ["brand_id", "brand_name", "business_id", "entry_page", "entry_page_url", "photos_count", "place_header_name", "place_name"],
  "photo_guide_viewed": ["brand_id", "brand_name", "business_id", "entry_page", "entry_page_url", "place_header_name", "place_name"],
  "photo_info_closed": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "photo_info_opened": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "photo_info_view_changed": ["brand_id", "brand_name", "business_id", "photo_index", "photo_info_type", "place_header_name", "place_name", "place_space_name", "previous_photo_info_type"],
  "photo_lightbox_closed": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "photo_lightbox_opened": ["brand_id", "brand_name", "business_id", "entry_page", "photo_index", "photos_count", "place_header_name", "place_name", "place_space_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "photo_navigated": ["brand_id", "brand_name", "business_id", "navigation_direction", "photo_collection", "photo_index", "photo_view_type", "place_header_name", "place_name", "place_space_name", "previous_photo_index", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "photo_source_cta_activated": ["brand_id", "brand_name", "business_id", "photo_source", "place_name"],
  "photo_source_menu_closed": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "photo_source_menu_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "photo_zoomed": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id", "zoom_direction", "zoom_level"],
  "place_alert_add_cta_activated": ["brand_id", "brand_name", "business_id", "pin_type", "place_name"],
  "place_alert_expanded": ["alert_type", "brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "place_alert_view_changed": ["alert_type", "place_space_name", "previous_alert_type"],
  "place_carousel_navigated": ["entry_index", "navigation_direction", "pin_type"],
  "place_claim_cta_activated": ["brand_id", "brand_name", "business_id", "place_name"],
  "place_closed": [],
  "place_content_view_changed": ["brand_id", "brand_name", "business_id", "interaction_method", "place_content_type", "place_name", "previous_place_content_type"],
  "place_custom_info_viewed": ["brand_id", "brand_name", "business_id", "custom_info_name", "place_name"],
  "place_experience_share_cta_activated": ["brand_id", "brand_name", "business_id", "entry_page", "place_name"],
  "place_external_link_cta_activated": ["booking_platform", "brand_id", "brand_name", "business_id", "link_destination", "place_name"],
  "place_header_view_changed": ["brand_id", "brand_name", "business_id", "interaction_method", "place_header_name", "place_name", "place_space_name", "previous_place_header_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "place_info_add_cta_activated": ["brand_id", "brand_name", "business_id", "entry_page", "pin_type", "place_name"],
  "place_info_view_changed": ["brand_id", "brand_name", "business_id", "guide_name", "interaction_method", "place_header_name", "place_info_type", "place_name", "previous_place_header_name", "previous_place_info_type"],
  "place_notification_cta_activated": ["brand_id", "brand_name", "business_id", "pin_type", "place_name"],
  "place_notification_form_closed": ["notification_audience"],
  "place_notification_form_opened": ["brand_id", "brand_name", "business_id", "enabled_notification", "notification_audience", "place_name"],
  "place_notification_subscribed": ["brand_id", "brand_name", "business_id", "enabled_notification", "notification_audience", "place_name", "previous_enabled_notification"],
  "place_notification_unsubscribed": ["brand_id", "brand_name", "business_id", "enabled_notification", "place_name", "previous_enabled_notification"],
  "place_opening_hours_expanded": [],
  "place_pin_selected": ["brand_id", "brand_name", "business_id", "entry_index", "pin_type", "place_name"],
  "place_save_cta_activated": ["brand_id", "brand_name", "business_id", "entry_page", "pin_type", "place_name"],
  "place_search_performed": ["brand_id", "brand_name", "business_id", "filters_count", "place_name", "search_method", "search_query", "search_result_type", "selected_filter"],
  "place_search_results_viewed": ["entry_index", "filters_count", "pin_type", "place_category", "results_count", "results_without_data_count", "search_coordinate", "search_method", "search_query", "search_radius_km", "search_result_type", "selected_filter", "view_type"],
  "place_share_cta_activated": ["brand_id", "brand_name", "business_id", "place_name"],
  "place_space_closed": ["brand_id", "brand_name", "business_id", "place_name", "place_space_name"],
  "place_space_viewed": ["brand_id", "brand_name", "business_id", "entry_page", "entry_page_url", "interaction_method", "place_header_name", "place_name", "place_space_name", "previous_place_space_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "place_summary_expanded": ["brand_id", "brand_name", "business_id", "place_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "place_tag_add_cta_activated": ["brand_id", "brand_name", "business_id", "pin_type", "place_name"],
  "place_viewed": ["brand_id", "brand_name", "business_id", "entry_index", "entry_page", "entry_page_url", "entry_type", "photos_count", "pin_type", "place_address", "place_category", "place_name", "place_template_type", "tags_count", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "profile_menu_closed": [],
  "profile_menu_opened": ["entry_page"],
  "profile_setup_closed": [],
  "profile_setup_step_skipped": ["step_index", "step_name"],
  "profile_setup_step_viewed": ["navigation_direction", "previous_step_index", "step_index", "step_name"],
  "profile_setup_submitted": ["step_name"],
  "recent_searches_viewed": [],
  "remove_photo_dialog_closed": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "remove_photo_dialog_opened": ["brand_id", "brand_name", "business_id", "photo_index", "place_header_name", "place_name", "place_space_name"],
  "remove_team_member_dialog_closed": [],
  "remove_team_member_dialog_opened": [],
  "resolve_alert_dialog_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "resolve_alert_dialog_opened": ["alert_id", "brand_id", "brand_name", "business_id", "place_name"],
  "save_place_form_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "save_place_form_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "saved_accessibility_filters_form_closed": [],
  "saved_accessibility_filters_form_opened": ["entry_point", "filters_count", "selected_filter"],
  "saved_accessibility_filters_updated": ["filters_count", "selected_filter"],
  "saved_landing_viewed": ["entry_page", "entry_page_url"],
  "saved_list_created": ["save_list_name"],
  "saved_my_business_viewed": [],
  "saved_place_added": ["brand_id", "brand_name", "business_id", "lists_count", "place_name"],
  "saved_place_list_deleted": ["places_count"],
  "saved_place_list_rename_form_closed": ["places_count"],
  "saved_place_list_rename_form_opened": ["places_count"],
  "saved_place_list_renamed": ["places_count"],
  "saved_place_list_settings_menu_closed": ["places_count"],
  "saved_place_list_settings_menu_opened": ["places_count"],
  "saved_place_list_share_cta_activated": [],
  "saved_place_list_view_changed": ["view_type"],
  "saved_place_list_viewed": ["entry_page", "entry_page_url", "lists_count", "places_count"],
  "saved_place_removed": ["lists_count"],
  "saved_places_viewed": ["lists_count"],
  "saved_search_added": ["filters_count", "search_query", "selected_filter"],
  "saved_search_cta_activated": [],
  "saved_search_details_viewed": ["filters_count", "selected_filter"],
  "saved_search_edit_form_closed": [],
  "saved_search_edit_form_opened": [],
  "saved_search_expanded": ["filters_count", "search_query", "selected_filter"],
  "saved_search_form_closed": [],
  "saved_search_form_opened": [],
  "saved_search_removed": ["filters_count", "search_query", "selected_filter"],
  "saved_search_updated": ["filters_count", "selected_filter"],
  "saved_searches_viewed": ["saved_searches_count"],
  "search_cleared": [],
  "search_list_closed": [],
  "search_list_viewed": [],
  "search_page_viewed": ["entry_page", "entry_page_url", "entry_type"],
  "search_results_pin_view_changed": ["brand_id", "brand_name", "business_id", "pin_data_type", "place_name", "previous_pin_data_type"],
  "search_view_changed": ["interaction_method", "previous_search_view_type", "search_view_type"],
  "share_experience_form_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "share_experience_form_opened": ["brand_id", "brand_name", "business_id", "place_name"],
  "site_alerts_viewed": ["brand_id", "brand_name", "business_id", "place_name"],
  "sort_changed": ["previous_sort_method", "sort_method"],
  "space_action_menu_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "space_action_menu_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "space_add_info_menu_closed": ["brand_id", "brand_name", "business_id", "place_name"],
  "space_add_info_menu_opened": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "space_added": ["brand_id", "brand_name", "business_id", "connected_space", "connected_space_count", "place_header_name", "place_name", "place_space_name", "space_creation_method", "tag_status"],
  "space_deleted": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "space_edited": ["brand_id", "brand_name", "business_id", "connected_space", "connected_space_count", "place_header_name", "place_name", "place_space_name"],
  "space_flag_cta_activated": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "space_flagged": ["brand_id", "brand_name", "business_id", "photos_count", "place_header_name", "place_name", "place_space_name"],
  "space_info_cleared": ["brand_id", "brand_name", "business_id", "photos_count", "place_header_name", "place_name", "place_space_name", "tags_count"],
  "space_photo_added": ["alt_text_skipped_count", "brand_id", "brand_name", "business_id", "photos_count", "photos_with_alt_text_count", "place_header_name", "place_name", "place_space_name", "selected_accessibility_tag", "tag_status", "tags_count"],
  "space_photo_removed": ["brand_id", "brand_name", "business_id", "photo_index", "photos_count", "place_header_name", "place_name", "place_space_name", "removed_count", "tags_count"],
  "space_search_performed": ["brand_id", "brand_name", "business_id", "filters_count", "place_name", "place_space_name", "results_count", "selected_filter", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "space_share_cta_activated": ["place_space_name"],
  "space_tags_added": ["brand_id", "brand_name", "business_id", "photos_count", "place_header_name", "place_name", "place_space_name", "tag_status", "tags_count"],
  "space_tags_edited": ["brand_id", "brand_name", "business_id", "photos_count", "place_header_name", "place_name", "place_space_name", "tag_status", "tags_count"],
  "support_cta_activated": ["brand_id", "brand_name", "business_id", "entry_page", "entry_point", "place_name", "support_type"],
  "support_page_viewed": ["brand_id", "brand_name", "business_id", "entry_page", "entry_point", "place_name"],
  "tag_header_viewed": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "space_count"],
  "tag_space_details_viewed": ["brand_id", "brand_name", "business_id", "photos_count", "place_header_name", "place_name", "place_space_name", "tag_status", "tags_count"],
  "team_create_form_closed": [],
  "team_create_form_opened": [],
  "team_created": [],
  "team_deleted": ["team_members_count"],
  "team_invite_dialog_closed": [],
  "team_invite_dialog_opened": ["team_members_count"],
  "team_joined": ["team_members_count"],
  "team_landing_viewed": ["entry_page", "entry_page_url", "teams_count"],
  "team_left": ["team_members_count"],
  "team_member_action_menu_closed": [],
  "team_member_action_menu_opened": [],
  "team_member_profile_viewed": ["entry_point", "profile_tab", "team_members_count"],
  "team_member_removed": ["target_account_id"],
  "team_qr_code_closed": [],
  "team_qr_code_opened": ["team_members_count"],
  "team_rename_form_closed": [],
  "team_rename_form_opened": [],
  "team_renamed": ["team_members_count"],
  "team_settings_menu_closed": [],
  "team_settings_menu_opened": ["team_members_count"],
  "team_share_cta_activated": ["share_method", "team_members_count"],
  "team_share_menu_closed": [],
  "team_share_menu_opened": [],
  "team_viewed": ["entry_page", "entry_page_url", "team_members_count"],
  "unsave_place_dialog_closed": [],
  "unsave_place_dialog_opened": [],
  "unsave_search_form_closed": [],
  "unsave_search_form_opened": [],
  "update_live_alerts_closed": ["brand_id", "brand_name", "business_id", "existing_alerts_count", "place_name"],
  "update_live_alerts_viewed": ["brand_id", "brand_name", "business_id", "entry_page", "entry_page_url", "existing_alerts_count", "place_name"],
  "update_password_form_closed": [],
  "update_password_form_opened": [],
  "update_personal_details_form_closed": [],
  "update_personal_details_form_opened": [],
  "upload_photo_viewed": ["brand_id", "brand_name", "business_id", "place_header_name", "place_name", "place_space_name"],
  "user_blocked": ["target_account_id"],
  "user_flagged": ["photos_count", "target_account_id"],
  "user_profile_action_menu_closed": [],
  "user_profile_action_menu_opened": [],
  "verify_email_viewed": [],
  "view_place_cta_activated": ["brand_id", "brand_name", "business_id", "entry_point", "place_name"],
  "vote_alert_cta_activated": ["alert_age_days", "alert_title", "brand_id", "brand_name", "business_id", "place_name", "vote_type"],
  "vote_alert_form_closed": ["alert_title", "brand_id", "brand_name", "business_id", "place_name", "vote_type"],
  "vote_alert_form_opened": ["alert_age_days", "alert_title", "brand_id", "brand_name", "business_id", "place_name", "vote_type"],
  "widget_added": ["widget_content_type", "widget_display_type", "widget_id", "widget_name", "widget_status"],
  "widget_change_location_list_closed": ["widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "widget_change_location_list_viewed": ["widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "widget_closed": ["widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "widget_code_copy_cta_activated": ["widget_content_type", "widget_display_type", "widget_id", "widget_name", "widget_status"],
  "widget_deleted": ["widget_content_type", "widget_display_type", "widget_id", "widget_name", "widget_status"],
  "widget_edited": ["widget_content_type", "widget_display_type", "widget_id", "widget_name", "widget_status"],
  "widget_editor_closed": ["editor_status", "widget_content_type", "widget_display_type", "widget_id", "widget_name", "widget_status"],
  "widget_editor_opened": ["editor_status", "widget_content_type", "widget_display_type", "widget_id", "widget_name", "widget_status"],
  "widget_loaded": ["widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "widget_location_changed": ["location_name", "previous_location_name", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "widget_location_viewed": ["location_name", "widget_content_type", "widget_display_type", "widget_entry_type", "widget_host_url", "widget_id"],
  "widget_opened": ["widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "widget_redirect_cta_activated": ["brand_id", "brand_name", "business_id", "place_name", "redirect_source", "widget_content_type", "widget_display_type", "widget_host_url", "widget_id"],
  "widget_status_changed": ["previous_widget_status", "widget_content_type", "widget_display_type", "widget_id", "widget_name", "widget_status"],
};

export interface PropDescriptor {
  type: "string" | "number" | "boolean" | "list";
  optional: boolean;
}

export const EVENT_PROPERTY_SCHEMA: Record<EventName, Record<string, PropDescriptor>> = {
  "accessibility_alerts_closed": {
    alerts_count: { type: "number", optional: false },
  },
  "accessibility_alerts_viewed": {
    alerts_count: { type: "number", optional: false },
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "accessibility_guide_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "accessibility_profile_form_closed": {},
  "accessibility_profile_form_opened": {},
  "accessibility_profile_updated": {},
  "account_auto_logged_in": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "account_created": {
    account_creation_method: { type: "string", optional: false },
  },
  "account_deleted": {},
  "account_logged_in": {
    auth_provider: { type: "string", optional: false },
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: true },
    place_name: { type: "string", optional: true },
  },
  "account_logged_out": {},
  "account_login_failed": {
    auth_provider: { type: "string", optional: false },
    error_type: { type: "string", optional: false },
  },
  "account_privacy_changed": {
    setting_type: { type: "string", optional: false },
    setting_value: { type: "string", optional: false },
  },
  "activity_filtered": {
    activity_type: { type: "string", optional: false },
    date_range: { type: "string", optional: false },
    filter_type: { type: "string", optional: false },
  },
  "activity_view_changed": {
    activity_type: { type: "string", optional: false },
    interaction_method: { type: "string", optional: false },
    previous_activity_type: { type: "string", optional: false },
  },
  "activity_viewed": {
    activity_type: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
  },
  "add_alert_form_closed": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_alert_form_opened": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    existing_alerts_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_info_menu_closed": {},
  "add_info_menu_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_mapper_note_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    mapper_note_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_mapper_note_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    mapper_note_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_note_menu_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_note_menu_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_space_discard_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_space_discard_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_space_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "add_space_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_added": {
    alert_frontend_status: { type: "string", optional: true },
    alert_location_name: { type: "string", optional: false },
    alert_status: { type: "string", optional: true },
    alert_title: { type: "string", optional: false },
    alert_type: { type: "string", optional: false },
    alerts_added_count: { type: "number", optional: false },
    alerts_count: { type: "number", optional: false },
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    mapper_note_type: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_added_confirmation_viewed": {
    alerts_count: { type: "number", optional: false },
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_deleted": {
    alert_age_days: { type: "number", optional: false },
    alert_frontend_status: { type: "string", optional: true },
    alert_location_name: { type: "string", optional: false },
    alert_status: { type: "string", optional: false },
    alert_title: { type: "string", optional: false },
    alert_type: { type: "string", optional: false },
    alerts_count: { type: "number", optional: false },
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_edited": {
    alert_frontend_status: { type: "string", optional: true },
    alert_location_name: { type: "string", optional: false },
    alert_status: { type: "string", optional: true },
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_flag_cta_activated": {
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_flagged": {
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_resolved": {
    alert_age_days: { type: "number", optional: false },
    alert_title: { type: "string", optional: false },
    alert_type: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "alert_unvoted": {
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    vote_type: { type: "string", optional: false },
  },
  "alert_voted": {
    alert_age_days: { type: "number", optional: false },
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
    vote_type: { type: "string", optional: false },
  },
  "analytics_page_viewed": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    entry_point: { type: "string", optional: true },
    place_name: { type: "string", optional: false },
  },
  "analytics_site_changed": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    previous_business_id: { type: "string", optional: false },
  },
  "app_accessibility_setting_changed": {
    setting_type: { type: "string", optional: false },
    setting_value: { type: "string", optional: false },
  },
  "app_accessibility_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
  },
  "area_map_results_viewed": {
    area_map_name: { type: "string", optional: false },
    entry_index: { type: "number", optional: false },
    filters_count: { type: "number", optional: false },
    place_category: { type: "string", optional: false },
    results_count: { type: "number", optional: false },
    search_coordinate: { type: "string", optional: false },
    search_method: { type: "string", optional: false },
    search_query: { type: "string", optional: false },
    search_radius_km: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
    view_type: { type: "string", optional: false },
  },
  "area_map_share_cta_activated": {},
  "area_map_viewed": {
    area_map_name: { type: "string", optional: false },
    results_count: { type: "number", optional: false },
  },
  "assign_alt_text_discard_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "assign_alt_text_discard_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "assign_alt_text_step_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    navigation_direction: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    previous_step_index: { type: "number", optional: false },
    step_index: { type: "number", optional: false },
    step_name: { type: "string", optional: false },
    tag_status: { type: "string", optional: false },
  },
  "assign_tags_discard_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "assign_tags_discard_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "assign_tags_exited": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "assign_tags_step_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    navigation_direction: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    previous_step_index: { type: "number", optional: false },
    step_index: { type: "number", optional: false },
    step_name: { type: "string", optional: false },
  },
  "auth_email_submitted": {
    auth_result: { type: "string", optional: false },
  },
  "auth_form_closed": {
    auth_screen: { type: "string", optional: false },
  },
  "auth_form_opened": {
    entry_page: { type: "string", optional: false },
    entry_point: { type: "string", optional: false },
  },
  "auth_password_reset_viewed": {},
  "auth_password_viewed": {},
  "auth_signup_viewed": {
    step_index: { type: "number", optional: false },
    step_name: { type: "string", optional: false },
  },
  "auth_social_cta_activated": {
    auth_provider: { type: "string", optional: false },
  },
  "badges_viewed": {
    current_level: { type: "number", optional: false },
    current_points: { type: "number", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    points_to_next_level: { type: "number", optional: false },
  },
  "block_user_cta_activated": {},
  "block_user_form_closed": {},
  "block_user_form_opened": {},
  "blog_cta_activated": {},
  "brand_viewed": {},
  "business_claimed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    contact_method: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "change_cover_photo_form_closed": {},
  "change_cover_photo_form_opened": {
    entry_page: { type: "string", optional: false },
  },
  "change_location_list_closed": {},
  "change_location_list_viewed": {},
  "change_location_map_form_closed": {},
  "change_location_map_form_opened": {},
  "claim_business_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "claim_business_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "clear_space_info_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "clear_space_info_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "community_subscribe_cta_activated": {},
  "connected_space_list_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    connected_space_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "cover_photo_updated": {
    cover_photo_type: { type: "string", optional: false },
    photo_source: { type: "string", optional: false },
  },
  "create_saved_list_form_closed": {},
  "create_saved_list_form_opened": {},
  "custom_info_added": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    custom_info_name: { type: "string", optional: false },
    custom_info_status: { type: "string", optional: false },
    guide_type: { type: "string", optional: true },
    place_name: { type: "string", optional: false },
  },
  "custom_info_deleted": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    custom_info_name: { type: "string", optional: false },
    guide_type: { type: "string", optional: true },
    place_name: { type: "string", optional: false },
  },
  "custom_info_edited": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    custom_info_name: { type: "string", optional: false },
    custom_info_status: { type: "string", optional: false },
    guide_type: { type: "string", optional: true },
    place_name: { type: "string", optional: false },
  },
  "custom_info_editor_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    custom_info_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "custom_info_editor_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    custom_info_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "custom_info_reordered": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "delete_account_dialog_closed": {},
  "delete_account_dialog_opened": {},
  "delete_saved_place_list_dialog_closed": {
    places_count: { type: "number", optional: false },
  },
  "delete_saved_place_list_dialog_opened": {
    places_count: { type: "number", optional: false },
  },
  "delete_saved_search_dialog_closed": {},
  "delete_saved_search_dialog_opened": {},
  "delete_space_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "delete_space_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "delete_team_dialog_closed": {},
  "delete_team_dialog_opened": {},
  "device_permission_changed": {
    permission_state: { type: "string", optional: false },
    permission_type: { type: "string", optional: false },
  },
  "device_permissions_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
  },
  "duplicate_space_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "duplicate_space_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "edit_alert_form_closed": {
    alert_id: { type: "number", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "edit_alert_form_opened": {
    alert_id: { type: "number", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "edit_space_discard_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "edit_space_discard_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "edit_space_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "edit_space_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "edit_tags_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    tag_status: { type: "string", optional: false },
  },
  "email_app_cta_activated": {},
  "experience_flagged": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    experience_type: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "experience_shared": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
    rating: { type: "string", optional: false },
  },
  "external_link_cta_activated": {
    link_destination: { type: "string", optional: false },
  },
  "filter_applied": {
    custom_opening_hour_day: { type: "string", optional: true },
    custom_opening_hour_time: { type: "string", optional: true },
    filter_type: { type: "string", optional: false },
    filters_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "filter_cleared": {
    filters_count: { type: "number", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "filter_closed": {
    filter_type: { type: "string", optional: false },
    filters_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "filter_opened": {
    filter_type: { type: "string", optional: false },
    filters_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "finish_tagging_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "flag_alert_form_closed": {
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "flag_alert_form_opened": {
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "flag_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_info_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "flag_experience_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    experience_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "flag_experience_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    experience_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "flag_photo_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "flag_photo_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "flag_space_form_closed": {},
  "flag_space_form_opened": {
    alttext_state: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "flag_user_cta_activated": {},
  "flag_user_form_closed": {},
  "flag_user_form_opened": {},
  "forgot_password_cta_activated": {},
  "guide_added": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    guide_status: { type: "string", optional: false },
    guide_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    protection_type: { type: "string", optional: false },
    space_count: { type: "number", optional: false },
  },
  "guide_deleted": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    guide_status: { type: "string", optional: false },
    guide_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    space_count: { type: "number", optional: false },
  },
  "guide_duplicated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    guide_status: { type: "string", optional: false },
    guide_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    space_count: { type: "number", optional: false },
  },
  "guide_edited": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    guide_status: { type: "string", optional: false },
    guide_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    protection_type: { type: "string", optional: false },
    space_count: { type: "number", optional: false },
  },
  "guide_editor_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "guide_editor_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "guide_link_copy_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    guide_status: { type: "string", optional: false },
    guide_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "home_page_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    entry_type: { type: "string", optional: false },
  },
  "leave_team_dialog_closed": {},
  "leave_team_dialog_opened": {},
  "list_filtered": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    filter_results_count: { type: "number", optional: false },
    list_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    search_query: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "location_changed": {
    selection_method: { type: "string", optional: false },
  },
  "location_cta_activated": {},
  "manage_account_viewed": {},
  "manage_notification_form_closed": {},
  "manage_notification_form_opened": {
    enabled_notification: { type: "list", optional: false },
  },
  "manage_notifications_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    notification_type: { type: "string", optional: false },
  },
  "manage_photo_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    tag_status: { type: "string", optional: false },
  },
  "map_location_centered": {},
  "map_view_changed": {
    view_type: { type: "string", optional: false },
  },
  "map_zoomed": {
    zoom_direction: { type: "string", optional: false },
    zoom_level: { type: "number", optional: false },
  },
  "my_business_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "nav_tree_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "nav_tree_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "nearby_required_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "nearest_results_cta_activated": {
    search_location_source: { type: "string", optional: false },
  },
  "neighborhood_viewed": {
    city_name: { type: "string", optional: false },
  },
  "notification_read": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "notification_view_changed": {
    interaction_method: { type: "string", optional: false },
    notification_type: { type: "string", optional: false },
    previous_notification_type: { type: "string", optional: false },
  },
  "notifications_all_read": {
    notifications_marked_read_count: { type: "number", optional: false },
  },
  "notifications_filter_toggled": {
    filter_state: { type: "string", optional: false },
    filter_type: { type: "string", optional: false },
  },
  "notifications_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    notification_type: { type: "string", optional: false },
    unread_notifications_count: { type: "number", optional: false },
  },
  "onboarding_completed": {},
  "onboarding_skipped": {
    step_index: { type: "number", optional: false },
    step_name: { type: "string", optional: false },
  },
  "onboarding_step_viewed": {
    navigation_direction: { type: "string", optional: false },
    previous_step_index: { type: "number", optional: false },
    step_index: { type: "number", optional: false },
    step_name: { type: "string", optional: false },
  },
  "other_cities_viewed": {},
  "password_reset_completed": {},
  "password_reset_request_form_closed": {},
  "password_reset_request_form_opened": {},
  "password_reset_requested": {},
  "password_updated": {},
  "password_visibility_toggled": {
    visibility_state: { type: "string", optional: false },
  },
  "personal_details_updated": {},
  "photo_action_menu_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_action_menu_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_alt_text_toggled": {
    alttext_state: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "photo_collection_view_changed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_collection_type: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
    previous_photo_collection_type: { type: "string", optional: false },
  },
  "photo_flag_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_flagged": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_gallery_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "photo_gallery_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "photo_guide_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "photo_info_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_info_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_info_view_changed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    photo_info_type: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    previous_photo_info_type: { type: "string", optional: false },
  },
  "photo_lightbox_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "photo_lightbox_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "photo_navigated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    navigation_direction: { type: "string", optional: false },
    photo_collection: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    photo_view_type: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    previous_photo_index: { type: "number", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "photo_source_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_source: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "photo_source_menu_closed": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_source_menu_opened": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "photo_zoomed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
    zoom_direction: { type: "string", optional: false },
    zoom_level: { type: "number", optional: false },
  },
  "place_alert_add_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    pin_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_alert_expanded": {
    alert_type: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "place_alert_view_changed": {
    alert_type: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    previous_alert_type: { type: "string", optional: false },
  },
  "place_carousel_navigated": {
    entry_index: { type: "number", optional: false },
    navigation_direction: { type: "string", optional: false },
    pin_type: { type: "string", optional: false },
  },
  "place_claim_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_closed": {},
  "place_content_view_changed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    interaction_method: { type: "string", optional: false },
    place_content_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    previous_place_content_type: { type: "string", optional: false },
  },
  "place_custom_info_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    custom_info_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_experience_share_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_external_link_cta_activated": {
    booking_platform: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    link_destination: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_header_view_changed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    interaction_method: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    previous_place_header_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "place_info_add_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    pin_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_info_view_changed": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: false },
    guide_name: { type: "string", optional: false },
    interaction_method: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_info_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    previous_place_header_name: { type: "string", optional: false },
    previous_place_info_type: { type: "string", optional: false },
  },
  "place_notification_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    pin_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_notification_form_closed": {
    notification_audience: { type: "string", optional: false },
  },
  "place_notification_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    enabled_notification: { type: "list", optional: false },
    notification_audience: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_notification_subscribed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    enabled_notification: { type: "list", optional: false },
    notification_audience: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    previous_enabled_notification: { type: "list", optional: false },
  },
  "place_notification_unsubscribed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    enabled_notification: { type: "list", optional: false },
    place_name: { type: "string", optional: false },
    previous_enabled_notification: { type: "list", optional: false },
  },
  "place_opening_hours_expanded": {},
  "place_pin_selected": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_index: { type: "number", optional: false },
    pin_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_save_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    pin_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_search_performed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    filters_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
    search_method: { type: "string", optional: false },
    search_query: { type: "string", optional: false },
    search_result_type: { type: "string", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "place_search_results_viewed": {
    entry_index: { type: "number", optional: false },
    filters_count: { type: "number", optional: false },
    pin_type: { type: "string", optional: false },
    place_category: { type: "string", optional: false },
    results_count: { type: "number", optional: false },
    results_without_data_count: { type: "number", optional: false },
    search_coordinate: { type: "string", optional: false },
    search_method: { type: "string", optional: false },
    search_query: { type: "string", optional: false },
    search_radius_km: { type: "number", optional: false },
    search_result_type: { type: "string", optional: false },
    selected_filter: { type: "list", optional: false },
    view_type: { type: "string", optional: false },
  },
  "place_share_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_space_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "place_space_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    interaction_method: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    previous_place_space_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "place_summary_expanded": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "place_tag_add_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    pin_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "place_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_index: { type: "number", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    entry_type: { type: "string", optional: false },
    photos_count: { type: "number", optional: true },
    pin_type: { type: "string", optional: false },
    place_address: { type: "string", optional: false },
    place_category: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_template_type: { type: "string", optional: false },
    tags_count: { type: "number", optional: true },
    widget_content_type: { type: "string", optional: true },
    widget_display_type: { type: "string", optional: true },
    widget_host_url: { type: "string", optional: true },
    widget_id: { type: "string", optional: true },
  },
  "profile_menu_closed": {},
  "profile_menu_opened": {
    entry_page: { type: "string", optional: false },
  },
  "profile_setup_closed": {},
  "profile_setup_step_skipped": {
    step_index: { type: "number", optional: false },
    step_name: { type: "string", optional: false },
  },
  "profile_setup_step_viewed": {
    navigation_direction: { type: "string", optional: true },
    previous_step_index: { type: "number", optional: true },
    step_index: { type: "number", optional: false },
    step_name: { type: "string", optional: false },
  },
  "profile_setup_submitted": {
    step_name: { type: "string", optional: false },
  },
  "recent_searches_viewed": {},
  "remove_photo_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "remove_photo_dialog_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "remove_team_member_dialog_closed": {},
  "remove_team_member_dialog_opened": {},
  "resolve_alert_dialog_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "resolve_alert_dialog_opened": {
    alert_id: { type: "number", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "save_place_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "save_place_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "saved_accessibility_filters_form_closed": {},
  "saved_accessibility_filters_form_opened": {
    entry_point: { type: "string", optional: false },
    filters_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "saved_accessibility_filters_updated": {
    filters_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "saved_landing_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
  },
  "saved_list_created": {
    save_list_name: { type: "string", optional: false },
  },
  "saved_my_business_viewed": {},
  "saved_place_added": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    lists_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "saved_place_list_deleted": {
    places_count: { type: "number", optional: false },
  },
  "saved_place_list_rename_form_closed": {
    places_count: { type: "number", optional: false },
  },
  "saved_place_list_rename_form_opened": {
    places_count: { type: "number", optional: false },
  },
  "saved_place_list_renamed": {
    places_count: { type: "number", optional: false },
  },
  "saved_place_list_settings_menu_closed": {
    places_count: { type: "number", optional: false },
  },
  "saved_place_list_settings_menu_opened": {
    places_count: { type: "number", optional: false },
  },
  "saved_place_list_share_cta_activated": {},
  "saved_place_list_view_changed": {
    view_type: { type: "string", optional: false },
  },
  "saved_place_list_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    lists_count: { type: "number", optional: false },
    places_count: { type: "number", optional: false },
  },
  "saved_place_removed": {
    lists_count: { type: "number", optional: false },
  },
  "saved_places_viewed": {
    lists_count: { type: "number", optional: false },
  },
  "saved_search_added": {
    filters_count: { type: "number", optional: false },
    search_query: { type: "string", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "saved_search_cta_activated": {},
  "saved_search_details_viewed": {
    filters_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "saved_search_edit_form_closed": {},
  "saved_search_edit_form_opened": {},
  "saved_search_expanded": {
    filters_count: { type: "number", optional: false },
    search_query: { type: "string", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "saved_search_form_closed": {},
  "saved_search_form_opened": {},
  "saved_search_removed": {
    filters_count: { type: "number", optional: false },
    search_query: { type: "string", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "saved_search_updated": {
    filters_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
  },
  "saved_searches_viewed": {
    saved_searches_count: { type: "number", optional: false },
  },
  "search_cleared": {},
  "search_list_closed": {},
  "search_list_viewed": {},
  "search_page_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    entry_type: { type: "string", optional: false },
  },
  "search_results_pin_view_changed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    pin_data_type: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    previous_pin_data_type: { type: "string", optional: false },
  },
  "search_view_changed": {
    interaction_method: { type: "string", optional: false },
    previous_search_view_type: { type: "string", optional: false },
    search_view_type: { type: "string", optional: false },
  },
  "share_experience_form_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "share_experience_form_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "site_alerts_viewed": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: true },
    place_name: { type: "string", optional: true },
  },
  "sort_changed": {
    previous_sort_method: { type: "string", optional: false },
    sort_method: { type: "string", optional: false },
  },
  "space_action_menu_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "space_action_menu_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "space_add_info_menu_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "space_add_info_menu_opened": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "space_added": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    connected_space: { type: "list", optional: false },
    connected_space_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    space_creation_method: { type: "string", optional: false },
    tag_status: { type: "string", optional: false },
  },
  "space_deleted": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "space_edited": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    connected_space: { type: "list", optional: false },
    connected_space_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "space_flag_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "space_flagged": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "space_info_cleared": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    tags_count: { type: "number", optional: false },
  },
  "space_photo_added": {
    alt_text_skipped_count: { type: "number", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    photos_with_alt_text_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    selected_accessibility_tag: { type: "list", optional: false },
    tag_status: { type: "string", optional: false },
    tags_count: { type: "number", optional: false },
  },
  "space_photo_removed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photo_index: { type: "number", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    removed_count: { type: "number", optional: false },
    tags_count: { type: "number", optional: false },
  },
  "space_search_performed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    filters_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    results_count: { type: "number", optional: false },
    selected_filter: { type: "list", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "space_share_cta_activated": {
    place_space_name: { type: "string", optional: false },
  },
  "space_tags_added": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    tag_status: { type: "string", optional: false },
    tags_count: { type: "number", optional: false },
  },
  "space_tags_edited": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    tag_status: { type: "string", optional: false },
    tags_count: { type: "number", optional: false },
  },
  "support_cta_activated": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: true },
    entry_page: { type: "string", optional: false },
    entry_point: { type: "string", optional: true },
    place_name: { type: "string", optional: true },
    support_type: { type: "string", optional: false },
  },
  "support_page_viewed": {
    brand_id: { type: "string", optional: true },
    brand_name: { type: "string", optional: true },
    business_id: { type: "string", optional: true },
    entry_page: { type: "string", optional: false },
    entry_point: { type: "string", optional: true },
    place_name: { type: "string", optional: true },
  },
  "tag_header_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    space_count: { type: "number", optional: false },
  },
  "tag_space_details_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    photos_count: { type: "number", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
    tag_status: { type: "string", optional: false },
    tags_count: { type: "number", optional: false },
  },
  "team_create_form_closed": {},
  "team_create_form_opened": {},
  "team_created": {},
  "team_deleted": {
    team_members_count: { type: "number", optional: false },
  },
  "team_invite_dialog_closed": {},
  "team_invite_dialog_opened": {
    team_members_count: { type: "number", optional: false },
  },
  "team_joined": {
    team_members_count: { type: "number", optional: false },
  },
  "team_landing_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    teams_count: { type: "number", optional: false },
  },
  "team_left": {
    team_members_count: { type: "number", optional: false },
  },
  "team_member_action_menu_closed": {},
  "team_member_action_menu_opened": {},
  "team_member_profile_viewed": {
    entry_point: { type: "string", optional: false },
    profile_tab: { type: "string", optional: false },
    team_members_count: { type: "number", optional: false },
  },
  "team_member_removed": {
    target_account_id: { type: "string", optional: false },
  },
  "team_qr_code_closed": {},
  "team_qr_code_opened": {
    team_members_count: { type: "number", optional: false },
  },
  "team_rename_form_closed": {},
  "team_rename_form_opened": {},
  "team_renamed": {
    team_members_count: { type: "number", optional: false },
  },
  "team_settings_menu_closed": {},
  "team_settings_menu_opened": {
    team_members_count: { type: "number", optional: false },
  },
  "team_share_cta_activated": {
    share_method: { type: "string", optional: false },
    team_members_count: { type: "number", optional: false },
  },
  "team_share_menu_closed": {},
  "team_share_menu_opened": {},
  "team_viewed": {
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    team_members_count: { type: "number", optional: false },
  },
  "unsave_place_dialog_closed": {},
  "unsave_place_dialog_opened": {},
  "unsave_search_form_closed": {},
  "unsave_search_form_opened": {},
  "update_live_alerts_closed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    existing_alerts_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "update_live_alerts_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_page: { type: "string", optional: false },
    entry_page_url: { type: "string", optional: false },
    existing_alerts_count: { type: "number", optional: false },
    place_name: { type: "string", optional: false },
  },
  "update_password_form_closed": {},
  "update_password_form_opened": {},
  "update_personal_details_form_closed": {},
  "update_personal_details_form_opened": {},
  "upload_photo_viewed": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_header_name: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    place_space_name: { type: "string", optional: false },
  },
  "user_blocked": {
    target_account_id: { type: "string", optional: false },
  },
  "user_flagged": {
    photos_count: { type: "number", optional: false },
    target_account_id: { type: "string", optional: false },
  },
  "user_profile_action_menu_closed": {},
  "user_profile_action_menu_opened": {},
  "verify_email_viewed": {},
  "view_place_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    entry_point: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
  },
  "vote_alert_cta_activated": {
    alert_age_days: { type: "number", optional: false },
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    vote_type: { type: "string", optional: false },
  },
  "vote_alert_form_closed": {
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    vote_type: { type: "string", optional: false },
  },
  "vote_alert_form_opened": {
    alert_age_days: { type: "number", optional: false },
    alert_title: { type: "string", optional: false },
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    vote_type: { type: "string", optional: false },
  },
  "widget_added": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
    widget_name: { type: "string", optional: false },
    widget_status: { type: "string", optional: false },
  },
  "widget_change_location_list_closed": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_change_location_list_viewed": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_closed": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_code_copy_cta_activated": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
    widget_name: { type: "string", optional: false },
    widget_status: { type: "string", optional: false },
  },
  "widget_deleted": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
    widget_name: { type: "string", optional: false },
    widget_status: { type: "string", optional: false },
  },
  "widget_edited": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
    widget_name: { type: "string", optional: false },
    widget_status: { type: "string", optional: false },
  },
  "widget_editor_closed": {
    editor_status: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
    widget_name: { type: "string", optional: false },
    widget_status: { type: "string", optional: false },
  },
  "widget_editor_opened": {
    editor_status: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
    widget_name: { type: "string", optional: false },
    widget_status: { type: "string", optional: false },
  },
  "widget_loaded": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_location_changed": {
    location_name: { type: "string", optional: false },
    previous_location_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_location_viewed": {
    location_name: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_entry_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_opened": {
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_redirect_cta_activated": {
    brand_id: { type: "string", optional: false },
    brand_name: { type: "string", optional: false },
    business_id: { type: "string", optional: false },
    place_name: { type: "string", optional: false },
    redirect_source: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_host_url: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
  },
  "widget_status_changed": {
    previous_widget_status: { type: "string", optional: false },
    widget_content_type: { type: "string", optional: false },
    widget_display_type: { type: "string", optional: false },
    widget_id: { type: "string", optional: false },
    widget_name: { type: "string", optional: false },
    widget_status: { type: "string", optional: false },
  },
};
